export default __webpack_public_path__ + "static/Sundance_Institute_logo-6d21d2cbf2b079635e73270fa161e722.png";